if (!customElements.get('product-recommendations-slider')) {
  customElements.define(
    'product-recommendations-slider',
    class ProductRecommendationsSlider extends HTMLElement {
      connectedCallback() {
        this.recommendationsContentElement = this.querySelector('[data-recommendations-content]');
        if (!this.recommendationsContentElement || !this.dataset.url) return;

        this.visibilityObserver = new IntersectionObserver(this.onVisibilityChange.bind(this), {
          rootMargin: '0px 0px 400px 0px'
        });
        this.visibilityObserver.observe(this);
      }

      disconnectedCallback() {
        this.visibilityObserver?.disconnect();
      }

      onVisibilityChange(observerEntries) {
        if (!observerEntries.some(observerEntry => observerEntry.isIntersecting)) return;

        this.visibilityObserver.disconnect();
        this.loadRecommendations();
      }

      async loadRecommendations() {
        try {
          const response = await fetch(this.dataset.url);
          if (!response.ok) throw new Error(`Recommendations request failed: ${response.status}`);

          const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
          const fetchedContentElement = responseDocument.querySelector('[data-recommendations-content]');

          if (!fetchedContentElement?.querySelector('[data-recommendations-slider]')) {
            this.hidden = true;
            return;
          }

          this.recommendationsContentElement.innerHTML = fetchedContentElement.innerHTML;
          this.initSlider();
        } catch (error) {
          console.error(error);
          this.hidden = true;
        }
      }

      initSlider() {
        const sliderElement = this.querySelector('[data-recommendations-slider]');

        if (window.T4SThemeSP?.Carousel) {
          sliderElement.flickityt4s = new T4SThemeSP.Carousel(sliderElement);
        }

        window.T4SThemeSP?.reinitProductGridItem?.();

        document.dispatchEvent(
          new CustomEvent('product-recommendations-slider:loaded', {
            detail: { sliderElement }
          })
        );
      }
    }
  );
}
